/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "review-order",
	props:{
		orderId:{
			default: null
		},
		orderDeliveryId: {
			default: null
		}
	},
	data() {
		return {
			order: {},
			orderGrandTotal: 0,
			billingAddress:null,
			shippingAddress: null,
			totalForOrder: 0,
			acceptOrder: {
				hasError: false,
				errorMessage: null,
				value: null
			},
			notes: null,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			orderItemsHeadings: [
				{
					text: "Product",
					field: "product"
				},
				{
					text: "Price",
					field: "priceAsString"
				},
				{
					text: "Quantity/Litres",
					field: "quantity"
				},
				// {
				// 	text: "Amount Dispensed",
				// 	field: "quantityDispensed"
				// },
				{
					text: "Total",
					field: "totalAsString"
				},
				// {
				// 	text: "Total Price Dispensed",
				// 	field: "totalDispensedAsString"
				// }
			],
			actions: [],
			actionKeys:{
				edit: "edit",
				delete: "delete"
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			loadingBillingAddress: false,
			selectedHeartbeatStatusCodeId: null,
			successModal:{
				modalHeading: "Success",
				modalMessage: null,
				elementId: "reviewOrderSuccessModal",
				showModal: false
			}
		};
	},
	methods: {
		getOrder(){
			this.loading = true;
			orderService.getOrderForDelivery(this.orderId, this.orderDeliveryId).then(
				successResponse =>{
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.order = successResponse.data.result;
						this.order = dataTableHelper.castObjectValues(this.order);
						//this.order.orderItems = dataTableHelper.castObjectValues(this.order.orderItems);
						// for(let i = 0; i < this.order.orderItems.length; i++){
						// 	this.order.orderItems[i].priceAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].unitPrice);
						// 	this.order.orderItems[i].totalAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].totalAmount);
						// 	//this.order.orderItems[i].totalDispensedAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].totalPriceDispensed);
						// 	//this.order.total += this.order.orderItems[i].total;
						// }
						this.order.totalAsString = currencyHelper.numberToCurrency(this.order.totalAmount);
						this.orderGrandTotal = this.order.totalAmount;
						if(this.order.discountedAmount !== null && this.order.discountedAmount > 0) {
							this.orderGrandTotal = this.order.totalAmount - this.order.discountedAmount;
						}
						this.orderGrandTotal = currencyHelper.numberToCurrency(this.orderGrandTotal);
						console.log("order", this.order);
						this.setBreadcrumbs();
						this.getCustomerShippingAddresses();
						this.getCustomerBillingAddress();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getOrderItems() {
		},
		getCustomerShippingAddresses(){
			this.loadingBillingAddress = true;
			customerService.getCompanyAddress(this.order.shippingAddressId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.shippingAddress = successResponse.data.result;
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerBillingAddress(){
			this.loadingBillingAddress = true;
			customerService.getCompanyAddress(this.order.billingAddressId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.billingAddress = successResponse.data.result;
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		validateAcceptOrRejectOfOrder(){
			if(this.acceptOrder.value === null){
				this.acceptOrder.hasError = true;
				this.acceptOrder.errorMessage = "Please select whether or not to accept or reject the order"
			}
			else{
				// save
				this.saveAcceptOrRejectOfOrder();
			}
		},
		saveAcceptOrRejectOfOrder(){
			this.loading = true;
			let request = {
				orderId: this.orderId,
				orderAccepted: this.acceptOrder.value,
				acceptedReason: this.notes,
				orderDeliveryId: this.orderDeliveryId,
				companyId: this.order.companyId
			};
			orderService.acceptOrRejectDeliveryOrder(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.successModal.showModal = true;
						this.successModal.modalMessage = "Order Reviewed Successfully"
						// if(this.acceptOrder.value){
						// 	//self.$router.go(-1);
						// 	if(this.order.orderTypeId === orderHelper.orderType.delivery){
						// 		this.$router.replace("/orders/scheduleOrderForDelivery/" + this.orderId);
						// 	}
						// 	else{
						// 		this.$router.go(-1);
						// 	}
						// }
						// else{
						// 	this.$router.go(-1);
						// }
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onSuccessModalOkClick(){
			// if(this.acceptOrder.value){
			// 	//self.$router.go(-1);
			// 	if(this.order.orderTypeId === orderHelper.orderType.delivery){
			// 		this.$router.replace("/orders/scheduleOrderForDelivery/" + this.orderId + "/" +this.orderDeliveryId);
			// 	}
			// 	else{
			// 		this.$router.go(-1);
			// 	}
			// }
			// else{
			// 	this.$router.go(-1);
			// }
			this.$router.go(-1);
		},
		setBreadcrumbs() {
			var pageTitle = "Review Order - #" + this.order.orderId + " (" + this.order.registeredCompanyName + ")";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		//this.setBreadcrumbs();
		// this.getProvinces();
		// this.getShippingAreas();
		// this.getShippingZones();
	},
	watch:{
		orderId:{
			handler: function () {
				console.log("orderId", this.orderId);
				if (this.orderId !== null && this.orderId > 0) {
					this.getOrder();
				}
			},
			immediate: true,
			deep: true
		}
	}
};